var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "has-text-left", attrs: { id: "tos" } }, [
      _vm._v(
        "\n  EASY UPLOADER（以下、当サイト)は、本利用規約に同意される方のみ利用できる。"
      ),
      _c("br"),
      _vm._v(
        "\n  尚、本利用規約は当サイトへアクセスし、サービスを利用した時点で有効とする。同意しない場合は利用できない。"
      ),
      _c("br"),
      _vm._v(" "),
      _c("br"),
      _vm._v("\n  A.利用規約を要約したもの"),
      _c("br"),
      _vm._v(" "),
      _c("br"),
      _vm._v("\n  1.日本国憲法及び法律を守る。"),
      _c("br"),
      _vm._v("\n  2.自己責任で利用し管理者は一切の責任を負わない。"),
      _c("br"),
      _vm._v("\n  3.常識の範囲内で利用する。"),
      _c("br"),
      _vm._v(" "),
      _c("br"),
      _vm._v("\n  B.サービスの利用に関して"),
      _c("br"),
      _vm._v(" "),
      _c("br"),
      _vm._v(
        "\n  1.当サイトのすべては自己責任で利用するものとし、生じた不利益について管理者は一切の責任を負わない。"
      ),
      _c("br"),
      _vm._v(
        "\n  2.当サイトを利用する際に生じる全ての権利を管理者が持つものとする。（アップロードされたファイルに関する権利を除きます。）"
      ),
      _c("br"),
      _vm._v(
        "\n  3.利用規約は利用者に告知することなく変更できる。変更内容は改定と同時に適用される。"
      ),
      _c("br"),
      _vm._v("\n  4.日本の法律が適用される。"),
      _c("br"),
      _vm._v(
        "\n  5.当サイトのすべては予告無しに提供を中止、停止する可能性がある。"
      ),
      _c("br"),
      _vm._v(
        "\n  6.何らかのトラブルなどにより、利用規約を理解する事ができない場合はサービスを利用しない。"
      ),
      _c("br"),
      _vm._v(" "),
      _c("br"),
      _vm._v("\n  C.アップロードされたファイルに関して"),
      _c("br"),
      _vm._v(" "),
      _c("br"),
      _vm._v(
        "\n  1.アップロードされたファイルに関するすべてはアップロードした利用者が責任を持ち、管理者は一切の責任を負わない。"
      ),
      _c("br"),
      _vm._v(
        "\n  2.アップロードされたファイルに関する第三者との問題はアップロードした利用者が責任を持って解決する。"
      ),
      _c("br"),
      _vm._v(
        "\n  3.アップロードされたファイルに関して何らかの問題がある場合、管理者は処置する事ができるが、その義務はない。"
      ),
      _c("br"),
      _vm._v(" "),
      _c("br"),
      _vm._v("\n  D.禁止行為"),
      _c("br"),
      _vm._v(" "),
      _c("br"),
      _vm._v("\n  1.著作権など、他者の権利を侵害する行為。"),
      _c("br"),
      _vm._v("\n  2.日本の法律に違反する行為。"),
      _c("br"),
      _vm._v("\n  3.故意にサーバーに負担をかける行為。"),
      _c("br"),
      _vm._v("\n  4.運営に支障を来す恐れのある行為。"),
      _c("br"),
      _vm._v("\n  5.過多の連続アップロード。"),
      _c("br"),
      _vm._v(" "),
      _c("br"),
      _vm._v("\n  E.情報の開示/処置"),
      _c("br"),
      _vm._v(" "),
      _c("br"),
      _vm._v(
        "\n  1.当サイトの利用規約に違反、開示しなければならないと管理者が判断した場合は利用者の接続情報などを開示し、処置する事ができる。これは利用者が拒否することはできない。"
      ),
      _c("br"),
      _vm._v(
        "\n  2.法令などにより情報の開示を求められた場合、管理者は利用者の接続情報などの情報を第三者に開示する事ができる。これは利用者が拒否することはできない。"
      ),
      _c("br"),
      _vm._v(" "),
      _c("br"),
      _vm._v("\n  F.管理者について/権限"),
      _c("br"),
      _vm._v(" "),
      _c("br"),
      _vm._v(
        "\n  1.当サイトのすべてを管理者は、利用者・第三者・要望に関係無く処置、管理（削除など）することができる。また、その義務はない。"
      ),
      _c("br"),
      _vm._v(" "),
      _c("br"),
      _vm._v("\n  2018年 5月 13日 施行\n")
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-8a630950", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8a630950","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Tos.vue
// module id = null
// module chunks = 